import { useContext } from 'react';

import { ConfigContext } from 'Context/config';

import { useFeatureFlags } from 'Utilities/hooks';
import { isOfficeHours } from 'Utilities/isOfficeHours/isOfficeHours';

import { useAgentAvailability } from './useAgentAvailability';

export const useLiveChatAvailable = (): boolean => {
  const { configState } = useContext(ConfigContext);
  const { useAgentAvailabilityPolling } = useFeatureFlags();

  useAgentAvailability();

  return useAgentAvailabilityPolling
    ? (configState.agentAvailability?.liveChatAvailable ?? isOfficeHours())
    : isOfficeHours();
};
